import React from "react";
import { Fade } from "react-reveal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ProjectDetails = ({ project }) => {
  const {
    name,
    title,
    description,
    liveSite,
    clientSide,
    serverSide,
    images,
    technologies,
  } = project;

  const settings = {
    infinite: true,
    speed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'ease',
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: false,
    pauseOnHover: false,
    arrows: false,
    accessibility: false,
    dots: false,
  };

  return (
    <div>
      <Fade top>
        <div className="flex flex-col lg:flex-row   bg-gradient-to-r from-gray-900 to-transparent transition hover:shadow-xl mt-20">
          <div className="rotate-180 p-2 [writing-mode:_vertical-lr] hidden lg:block">
            <p className="text-primary font-semibold text-center">{title}</p>
          </div>

          <div className=" block basis-72">
            <Slider {...settings}>
              {
                images.map((image, idx) => <div key={idx} className="aspect-square h-72 lg:h-[400px]">
                  <img
                    alt="Project_Photos"
                    src={image}
                    className="  h-72 lg:h-full w-full cover"
                  />
                </div >)
              }

            </Slider>
          </div>

          <div className="flex flex-1 flex-col justify-between">
            <div className="border-l border-gray-900/10 p-4 sm:border-l-transparent sm:p-6">
              <a href={liveSite} target=" _blank">
                <h2 className="text-xl font-bold uppercase text-primary">{name}</h2>
              </a>

              <p className="mt-2 text-sm leading-relaxed  line-clamp-3">
                {description}
                <div className="mt-5">
                  <a
                    href={liveSite}
                    target=" _blank"
                    className="btn text-white  bg-teal-600 rounded border hover:bg-white hover:text-gray-900  font-bold btn-sm mr-3 mb-3"
                  >
                    🔗  Live Site
                  </a>
                  <a
                    href={clientSide}
                    target=" _blank"
                    className="btn text-white  bg-teal-600 rounded border hover:bg-white hover:text-gray-900  font-bold btn-sm mr-3 mb-3"
                  >
                    💻  Client Site
                  </a>
                  <a
                    href={serverSide}
                    target=" _blank"
                    className="btn text-white  bg-teal-600 rounded border hover:bg-white hover:text-gray-900  font-bold btn-sm mr-3 mb-3"
                  >
                    🛠️   Server Site
                  </a>
                </div>
                {/* technology  */}
                <div className=" flex flex-wrap">
                  {technologies.map((technology, idx) => (
                    <button
                      key={idx}
                      className="btn btn-outline btn-xs mr-2 mt-2"
                    >
                      {technology}
                    </button>
                  ))}
                </div>
              </p>
            </div>

            <div className="sm:flex sm:items-end sm:justify-end">
              {/* <Link
            href="#"
            className="block bg-teal-600  px-5 py-3 text-center  font-bold uppercase  transition hover:bg-white hover:text-black"
          >
            Details
          </Link> */}
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default ProjectDetails;
